async function setCart(products){
  const popup = document.getElementById('cart-popup')

  try {
    const items = products.map(({id, quantity = 1, sellingPlanId}) => {
      return {
        'id': id,
        'quantity': quantity,
        ...(sellingPlanId ? {'selling_plan' : sellingPlanId} : {})
      }
    })

    const newMembership = products.filter(i=>i.sellingPlanId)[0]
    const currentCart = await fetch(window.Shopify.routes.root + 'cart.js')
    .then(res=> res.json())
    const currentMemberships = currentCart.items.filter(i=>i.handle.includes('membership'))

    let updates = null
    currentMemberships.forEach(item=>{
      if(item.id !== newMembership.id){
        if(!updates) updates = {}
        updates[item.id] = 0
      }
    })

    if(updates){
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates })
      })    
    }
    
    const rawResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'items': items
      })
    })

    const response = await rawResponse.json()

    if (response.status) {
      return {status: 'ERROR', message: 'SOLD OUT'}
    }

    // Add to popup cart
    popup.open(document.activeElement, items.length)

    return {status: 'SUCCESS'}

  } catch (error) {
    console.error('Error:', error);
    return {status: 'ERROR', message: error.message}
  }
}